import { SKUS } from '@/constants';
import { Sku } from '@/types';

export const toCamelCase = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const mapValidSkus = (skus: Sku[]): Sku[] => {
  if (!skus) return [];
  const valid_skus = Object.values(SKUS);
  const result = skus?.filter((sku) => sku?.skuID && valid_skus.includes(sku.skuID));
  return valid_skus
    .map((f) => result?.find((sku) => sku.skuID === f))
    .filter((sku) => sku !== undefined) as Sku[];
};
